'use client';
import { useEffect, useState } from 'react';

const useHash = () => {
  const [hash, setHash] = useState<string>(
    typeof window === 'undefined' ? '' : window.location.hash?.substring?.(1)
  );

  useEffect(() => {
    function handleUrlChange() {
      setHash(window.location.hash.substring(1));
    }

    window.addEventListener('hashchange', handleUrlChange);

    return () => {
      window.removeEventListener('hashchange', handleUrlChange);
    };
  }, []);

  function clearHash() {
    window.history.replaceState(
      {},
      document.title,
      window.location.pathname + window.location.search
    );
    window.dispatchEvent(new Event('hashchange'));
  }

  return { hash, clearHash };
};

export default useHash;
